import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Bell, CheckCircle } from "lucide-react";
import axios from "axios";

const NotificationPage = () => {
  const [allNotifications, setAllNotifications] = useState([]);
  const [admin, setAdmin] = useState({});

  const token = localStorage.getItem("adminToken");

  const getProfile = async () => {
    if (!token) return;
    try {
      const response = await axios.get("https://wavetechservices.in/api/admin/profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setAdmin(response.data.admin);
    } catch (error) {
      console.error("Failed to get user profile:", error);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    setAllNotifications(admin?.notifications || []);
  }, [admin]);

  const formatDate = (isoString) => {
    const dateObj = new Date(isoString);
    return dateObj.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="max-w-4xl mx-auto my-20 p-6">
      <div className="flex items-center justify-center mb-8">
        <h2 className="text-3xl font-bold flex items-center gap-3">
          <Bell className="w-8 h-8 text-blue-600 animate-bounce" /> Notifications
        </h2>
      </div>

      <div className="space-y-3">
        {allNotifications?.slice().reverse().map((notif) => (
          <Card
            key={notif.id}
            className="p-2 bg-gradient-to-br from-blue-100 to-blue-300 shadow-lg rounded-xl transform transition-all hover:scale-105 hover:"
          >
            <CardContent className="flex flex-col gap-2">
              <div className="flex items-center justify-between">
                <p className="text-lg font-semibold text-gray-800">
                  {notif.message}
                </p>
                {/* <CheckCircle className="text-green-500 w-6 h-6 animate-pulse" /> */}
              </div>
              {notif.booking?._id && (
                <p className="text-sm text-gray-600">
                  Booking ID: <span className="font-medium">{notif.booking._id}</span>
                </p>
              )}
              <p className="text-xs text-gray-500 italic">{formatDate(notif.date)}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {allNotifications.length === 0 && (
        <p className="text-center text-gray-500 mt-10">No new notifications 📬</p>
      )}
    </div>
  );
};

export default NotificationPage;
